var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9583 3.16667V3.375H16.5C16.8452 3.375 17.125 3.65482 17.125 4C17.125 4.34518 16.8452 4.625 16.5 4.625H15.4583V14.8333C15.4583 16.099 14.4323 17.125 13.1667 17.125H4.83333C3.56768 17.125 2.54167 16.099 2.54167 14.8333V4.625H1.5C1.15482 4.625 0.875 4.34518 0.875 4C0.875 3.65482 1.15482 3.375 1.5 3.375H5.04167V3.16667C5.04167 1.90101 6.06768 0.875 7.33333 0.875H10.6667C11.9323 0.875 12.9583 1.90101 12.9583 3.16667ZM6.29167 3.16667C6.29167 2.59137 6.75804 2.125 7.33333 2.125H10.6667C11.242 2.125 11.7083 2.59137 11.7083 3.16667V3.375H6.29167V3.16667Z",
    fill: "#EB0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.ec49795e66f0bf58ca8744cfaaf1a39c.svg";
export { ForwardRef as ReactComponent };